import springCenfApi from '../../services/springCenfApi'

export const getTicketTypes = params => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get('/ticket_types', { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const getTicketType = (id, params) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.get(`/ticket_types/${id}`, { params })
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const storeTicketType = data => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.post('/ticket_types', data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const updateTicketType = (id, data) => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.put(`/ticket_types/${id}`, data)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)

export const deleteTicketType = id => (
	new Promise((resolve, reject) => {
		springCenfApi()
			.delete(`/ticket_types/${id}`)
				.then(res => resolve(res))
				.catch(error => reject(error))
	})
)